<template>
  <div v-if="item.children">
    <template v-if="item.children.length == 0">
      <el-menu-item :index="item.pagePath">
        <span class="icon" v-if="iconMap[item.iconResourceId]" v-html="iconMap[item.iconResourceId]"></span>
        <i v-else v-show="item.iconResourceId.length > 0" :class="item.iconResourceId" class="icon"></i>
        <span slot="title">{{ item.name }}</span>
      </el-menu-item>
    </template>
    <el-submenu v-else :index="item.id">
      <template slot="title">
        <span class="icon" v-if="iconMap[item.iconResourceId]" v-html="iconMap[item.iconResourceId]"></span>
        <i v-else v-show="item.iconResourceId.length > 0" :class="item.iconResourceId" class="icon"></i>
        <span slot="title">{{ item.name }}</span>
      </template>

      <template v-for="child in item.children">
        <sidebar-item v-if="child.children && child.children.length > 0" :item="child" />
        <el-menu-item v-else :index="child.pagePath">
          <span class="icon" v-if="iconMap[child.iconResourceId]" v-html="iconMap[child.iconResourceId]"></span>
          <i v-else v-show="child.iconResourceId.length > 0" :class="child.iconResourceId" class="icon"></i>
          <span slot="title">{{ child.name }}</span>
        </el-menu-item>
      </template>
    </el-submenu>
  </div>
</template>

<script>
import { getSvg } from 'common/src/svg'

export default {
  name: "SidebarItem",
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      iconMap: {},
    }
  },
  watch: {
    item: {
      immediate: true,
      handler() {
        this.loadIcons()
      },
    },
  },
  methods: {
    collectIconIds() {
      const ids = new Set()
      const add = (id) => {
        if (id && typeof id === 'string' && id.length > 0) {
          ids.add(id)
        }
      }
      add(this.item.iconResourceId)
      if (this.item.children) {
        this.item.children.forEach(child => add(child.iconResourceId))
      }
      return [...ids]
    },
    async loadIcons() {
      const ids = this.collectIconIds().filter(id => !this.iconMap[id])
      await Promise.all(
        ids.map(async (id) => {
          try {
            const file = await getSvg(id)
            this.$set(this.iconMap, id, file)
          } catch {
            // 非 SVG 名称（如 iconfont class）走 fallback
          }
        })
      )
    },
  },
};
</script>
<style lang="scss" scoped>
.iconfont {
  font-size: 14px;
}
</style>
<style>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  min-height: 400px;
}

/*隐藏文字*/
.el-menu--collapse .el-submenu__title span {
  display: none;
}
/*隐藏 > */
.el-menu--collapse .el-submenu__title .el-submenu__icon-arrow {
  display: none;
}
.icon {
  flex: 0 0 24px;
}
</style>
